import { MarketHeader } from '@/components/market/market-header';
import { PortfolioClient } from '@/components/market/portfolio-client';
import type { MarketPortfolio } from '@/types';

export default function Portfolio({ edition, initialState }: MarketPortfolio) {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-5 p-4 sm:p-6">
      <MarketHeader
        initialData={initialState}
        hackSlug={edition.slug}
        eventLabel={edition.eventLabel}
      />
      <PortfolioClient hackSlug={edition.slug} initialState={initialState} />
    </div>
  );
}
